export const exceptionHandlingAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }